/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CssPreview(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CssPreview',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M3.105 3.389c.13-.108.33-.139.895-.139v-1.5h-.07c-.445-.002-1.196-.004-1.785.486C1.5 2.773 1.25 3.7 1.25 5c0 1.092-.322 1.637-.593 1.907a1.3 1.3 0 0 1-.417.281 1 1 0 0 1-.234.062H0v1.5h.006l.07.01q.069.014.164.052c.127.051.275.139.417.28.27.271.593.816.593 1.908 0 1.3.25 2.227.895 2.764.589.49 1.34.488 1.786.486H4v-1.5c-.566 0-.765-.03-.895-.139C3 12.523 2.75 12.2 2.75 11c0-1.408-.428-2.363-1.032-2.968L1.685 8l.033-.032C2.322 7.363 2.75 6.408 2.75 5c0-1.2.25-1.523.355-1.611m9.79 0c-.13-.108-.33-.139-.895-.139v-1.5h.07c.445-.002 1.196-.004 1.785.486.645.537.895 1.463.895 2.764 0 1.092.322 1.637.593 1.907.142.142.29.23.417.281a1 1 0 0 0 .234.062H16v1.5h-.006l-.016.002a1 1 0 0 0-.219.06 1.3 1.3 0 0 0-.416.28c-.27.271-.593.816-.593 1.908 0 1.3-.25 2.227-.895 2.764-.589.49-1.34.488-1.786.486H12v-1.5c.566 0 .765-.03.895-.139.105-.088.355-.412.355-1.611 0-1.408.428-2.363 1.032-2.968L14.315 8l-.033-.032C13.678 7.363 13.25 6.408 13.25 5c0-1.2-.25-1.523-.355-1.611M5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"}))
}
